import { Injectable } from '@angular/core';

import { ScanPriority } from '../../models/scan-priority';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class ScanPriorityService extends BackendBaseService {
  /**
   * Base URL for controller
   * @type {string}
   */
  url: string = 'scan_priorities';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  /**
   * Save scan priority
   * @param  {ScanPriority} scanPriority Scan priority to save
   * @return {Promise<any>}              Server response
   */
  save(scanPriority: ScanPriority): Promise<any> {
    return super.save({
      id: scanPriority.id,
      scan_priority: scanPriority
    });
  }
}
